import './Dropdown.scss';

const Dropdown = ({ handleSelect, defaultValue, options }) => {
  return (
    <div className='Dropdown'>
      <select
        onChange={e => handleSelect(e.target.value)}
        defaultValue={defaultValue}
        key={options}
      >
        {
          options
            .filter(option => !!option.name && !!option.value)
            .map((option, i) => (
            <option
              key={i}
              value={option.value}
            >
              {option.name}
            </option>
          ))
        }
      </select>
      <span className='caret' />
    </div>
  );
}

export default Dropdown;